<div class="row">
    <ng-container *ngFor="let item of items">
        <div class="col-12" 
            [ngClass]="item?.alignment" 
            [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" 
            *ngIf="item?.type == 'HEADING'" 
            [innerHTML]="item?.content">
        </div>

        <div class="col-12">
            <div class="d-block mx-auto font-size-16" style="max-width: 700px;"
                [ngClass]="item?.alignment" 
                [style.padding-top.px]="item?.padding"
                [style.padding-bottom.px]="item?.padding" 
                *ngIf="item?.type == 'TEXTAREA'" 
            >
                {{ item?.content }}
            </div>
        </div>
    </ng-container>

    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 offset-md-1 offset-lg-1 offset-xl-1">
        <ng-container *ngFor="let faq of faqs">
            <h5 class="my-10">{{ faq?.category?.content }}</h5>

            <mat-accordion class="accordion-grey pb-accordion" displayMode="flat" multi>
                <ng-container *ngFor="let question of faq?.questions">
                    <mat-expansion-panel class="mat-elevation-z0 mb-4 rounded" hideToggle [style.margin-top.px]="question?.padding"
                    [style.margin-bottom.px]="faq?.padding">
                        <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
                            <mat-panel-title class="mr-0">
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col d-flex align-items-center">
                                            <p class="font-size-16 m-0">{{ question?.content?.question }}</p>
                                        </div>
                                        <div class="col-auto d-flex align-items-center">
                                            <button type="button" class="btn btn-circle btn-white btn-icon minimize">
                                                <i class="ki ki-arrow-up text-muted icon-sm"></i>
                                            </button>
                                            <button type="button" class="btn btn-circle btn-white btn-icon maximize"
                                                style="display: none;">
                                                <i class="ki ki-arrow-down text-muted icon-sm"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="mt-5 mb-0 font-size-16" [innerHTML]="question?.content?.answer">
                        </div>
                    </mat-expansion-panel>
                </ng-container>
            </mat-accordion>
        </ng-container>
    </div>
</div>
